export enum DB {
  groups = 'groups',
  userdata = 'userdata',
}
